export class PortfolioInfo {
  constructor() {
    this.develop = {
      es: 'Desarrollo de Software de Código Abierto',
      en: 'Open Source Software Development',
    }

    this.design = {
      es: 'Animación y Diseño 3D',
      en: '3D Animation & Design',
    }

    this.sound = {
      es: 'Producción y Postproducción Sonora',
      en: 'Audio & Postproduction',
    }
  }
}
